import { render, staticRenderFns } from "./pickUpEdit.vue?vue&type=template&id=65940df0&scoped=true&"
import script from "./pickUpEdit.vue?vue&type=script&lang=js&"
export * from "./pickUpEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65940df0",
  null
  
)

export default component.exports